import React from "react";

import {
  getProfessionalInitials,
  getReadableTextColor,
  normalizeHexColor,
} from "../../helpers/professionalAvatar";

export interface ProfessionalAvatarProps {
  name: string;
  colorHex: string;
  photoUrl?: string | null;
  size?: number;
  className?: string;
}

const ProfessionalAvatar: React.FC<ProfessionalAvatarProps> = ({
  name,
  colorHex,
  photoUrl,
  size = 48,
  className = "",
}) => {
  const backgroundColor = normalizeHexColor(colorHex);
  const textColor = getReadableTextColor(backgroundColor);
  const dimension = `${size}px`;
  const fontSize = Math.max(12, Math.round(size * 0.36));

  if (photoUrl) {
    return (
      <img
        src={photoUrl}
        alt=""
        aria-hidden="true"
        className={`rounded-circle object-fit-cover flex-shrink-0 ${className}`.trim()}
        style={{ width: dimension, height: dimension }}
      />
    );
  }

  return (
    <span
      aria-hidden="true"
      className={`rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0 fw-semibold ${className}`.trim()}
      style={{
        width: dimension,
        height: dimension,
        backgroundColor,
        color: textColor,
        fontSize,
        lineHeight: 1,
      }}
    >
      {getProfessionalInitials(name)}
    </span>
  );
};

export default ProfessionalAvatar;
